import { ROUTES } from './routes.js'

export type PlatformRole = 'SUPERADMIN' | 'ADMIN'

export interface PlatformOutletContext {
  platformRole: PlatformRole
}

export function platformOrganizationPath(organizationId: string): string {
  return `${ROUTES.PLATFORM_ORGANIZATIONS}/${encodeURIComponent(organizationId)}`
}
